type HasName = { name: string };
const hasName = (obj: any): obj is HasName => (
  typeof obj === 'object' && typeof obj.name === 'string'
);

/**
 * Identify if an error is associated with a cancelled network request.
 */
const isAbortedError = (err: unknown): boolean => {
  // When abort() is called, the fetch() promise rejects with an Error of type
  // DOMException, with name AbortError.
  if (hasName(err) && err.name === 'AbortError') {
    return true;
  }

  /**
   * @see https://stackoverflow.com/q/55738408/4851495
   * Safari 14 throws `TypeError: cancelled`
   * Safari 15 throws `TypeError: Load failed`
   * Chromium based throws `TypeError: Failed to fetch`
   * Firefox throws `TypeError: NetworkError when attempting to fetch resource.`
   */
  if (
    err instanceof TypeError
    && err.message.match(/^(cancelled|load failed|failed to fetch|NetworkError)/i)
  ) {
    return true;
  }

  return false;
};

export default isAbortedError;
